import createSvgIcon from '../Utils/CreateSvgIcon';

export const ChevronRight = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M14.7278 12.0711L8.36386 5.70712L9.77808 4.29291L17.5563 12.0711L9.77808 19.8493L8.36386 18.435L14.7278 12.0711Z"
    fillRule="evenodd"
  />,
  'ChevronRight',
);
